export default "__VITE_PUBLIC_ASSET__a475b7a9__"